import { useMemo, useState } from "react";
import { Alert, Button } from "react-bootstrap";

import { PageHeader } from "../../layout/secure/common";
import {
  authorizeWordPressInstallation,
  messageFromError,
} from "../../utils/api";

const requestedConnection = () => {
  const query = new URLSearchParams(window.location.search);
  return {
    publicInstallationId: query.get("installation") || "",
    state: query.get("state") || "",
    codeChallenge: query.get("code_challenge") || "",
    codeChallengeMethod: query.get("code_challenge_method") || "",
    callbackUrl: query.get("callback") || "",
    siteUrl: query.get("site_url") || "",
    homeUrl: query.get("home_url") || "",
    pluginVersion: query.get("plugin_version") || "",
    wordpressVersion: query.get("wordpress_version") || "",
    phpVersion: query.get("php_version") || "",
  };
};

function WordPressConnect() {
  const request = useMemo(requestedConnection, []);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const approve = async () => {
    setSubmitting(true);
    setError("");
    try {
      const result = await authorizeWordPressInstallation(request);
      if (!result?.redirectUrl) throw new Error("The connection callback was not returned.");
      window.location.assign(result.redirectUrl);
    } catch (requestError) {
      setError(messageFromError(
        requestError,
        "The WordPress connection could not be approved."
      ));
      setSubmitting(false);
    }
  };

  return (
    <>
      <PageHeader
        title="Connect WordPress"
        description="Authorize one WordPress site to list published surveys, read usage, and display approved survey embeds."
      />
      <section className="fera-panel fera-wordpress-connect" aria-labelledby="wordpress-connect-title">
        <div className="fera-panel-heading">
          <div>
            <p className="fera-eyebrow">FeraSurvey integration</p>
            <h2 id="wordpress-connect-title">Approve this site</h2>
          </div>
          <span className="badge text-bg-warning">Approval required</span>
        </div>
        {error ? <Alert variant="danger">{error}</Alert> : null}
        <dl className="fera-properties">
          <div><dt>WordPress site</dt><dd>{request.siteUrl || "Not provided"}</dd></div>
          <div><dt>Allowed embed origin</dt><dd>{request.homeUrl || request.siteUrl || "Not provided"}</dd></div>
          <div><dt>Plugin version</dt><dd>{request.pluginVersion || "Unknown"}</dd></div>
        </dl>
        <div className="fera-wordpress-scope-list">
          <h3>Requested access</h3>
          <ul>
            <li>Read this installation and connection status</li>
            <li>List embeddable published surveys and safe metadata</li>
            <li>Read the resolved Survey usage and upgrade options</li>
          </ul>
          <p>No survey answers, result exports, users, or billing controls are granted.</p>
        </div>
        <div className="fera-page-buttons">
          <Button type="button" variant="outline-secondary" onClick={() => window.history.back()}>
            Cancel
          </Button>
          <Button type="button" disabled={submitting} onClick={approve}>
            {submitting ? "Connecting\u2026" : "Approve WordPress connection"}
          </Button>
        </div>
      </section>
    </>
  );
}

export {
  requestedConnection,
};

export default WordPressConnect;
